import React from 'react';
import Link from 'components/link';
import { buildClassName } from 'utils/build-class-name';
import styles from './style.module.scss';

import type { ComponentType } from 'react';

type SocialLinkProps = {
  /** Agent-entered URL; `https://` is added when no scheme is present */
  link: string;
  label: string;
  Icon: ComponentType<{ className?: string }>;
  /** Sizing/layout class from the parent */
  className?: string;
  onClick: () => void;
};

const toExternalHref = (rawLink: string) => {
  const link = rawLink.trim();
  return link.startsWith('http://') || link.startsWith('https://') ? link : `https://${link}`;
};

export default function SocialLink({ link, label, Icon, className, onClick }: SocialLinkProps) {
  return (
    <Link
      href={toExternalHref(link)}
      target="_blank"
      rel="noopener noreferrer"
      className={buildClassName(styles.component, className)}
      onClick={onClick}
    >
      <Icon className={styles.icon} />
      {label}
    </Link>
  );
}
